import { render, staticRenderFns } from "./PolugodovojKursMnemotexnika.vue?vue&type=template&id=77985801&scoped=true&"
import script from "./PolugodovojKursMnemotexnika.vue?vue&type=script&lang=js&"
export * from "./PolugodovojKursMnemotexnika.vue?vue&type=script&lang=js&"
import style0 from "./PolugodovojKursMnemotexnika.vue?vue&type=style&index=0&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=css&"
import style1 from "./PolugodovojKursMnemotexnika.vue?vue&type=style&index=1&id=77985801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77985801",
  null
  
)

export default component.exports